import { render, staticRenderFns } from "./ProfilingTableResult.vue?vue&type=template&id=552506fe&lang=pug"
import script from "./ProfilingTableResult.vue?vue&type=script&lang=js"
export * from "./ProfilingTableResult.vue?vue&type=script&lang=js"
import style0 from "./ProfilingTableResult.vue?vue&type=style&index=0&id=552506fe&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552506fe')) {
      api.createRecord('552506fe', component.options)
    } else {
      api.reload('552506fe', component.options)
    }
    module.hot.accept("./ProfilingTableResult.vue?vue&type=template&id=552506fe&lang=pug", function () {
      api.rerender('552506fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profiling/ProfilingTableResult.vue"
export default component.exports